<div *ngIf="addMode || editMode || reuseMode">
    <div class="position-relative mt-4 mx-auto" style="width:835px; left:-14px">
        <button type="button" class="btn btn-text-gray btn-icon" (click)="cancel()">
            <svg><use href="../App_Themes/clearview-default/icons/utility/arrow-left.svg#arrow-left"></use></svg>
            <span cvLocalizedText langSection="Common" langKey="Back_Button">Back</span>
        </button>
    </div>
    <div class="content d-flex flex-column p-4 mt-4 mb-3 mx-auto" style="width:835px">
        <div class="d-flex font-size-24 color-theUpsideDown ml-5">
            <span *ngIf="addMode" cvLocalizedText langSection="Broadcasts" langKey="New_Announcement">New Announcement</span>
            <span *ngIf="editMode" cvLocalizedText langSection="Broadcasts" langKey="Edit_Announcement">Edit Announcement</span>
            <span *ngIf="reuseMode" cvLocalizedText langSection="Broadcasts" langKey="Reuse_Announcement">Reuse Announcement</span>
        </div>
        <hr class="w-50 mb-3 ml-5" />
        <div class="d-flex align-items-center mb-2">
            <img src="../App_Themes/clearview-default/icons/number/circle-1.svg">
            <span class="lato-bold font-size-16 color-theUpsideDown ml-4" cvLocalizedText langSection="Broadcasts" langKey="Recipients">Recipients</span>
        <span class="color-redRyder font-size-12 ml-3">{{errorMessages?.recipients}}</span>
        </div>
        <div class="ml-5">
            <div class="mb-2 color-valyrianSteel" cvLocalizedText langSection="Broadcasts" langKey="Announcement_Assign_Tooltip">Choose the groups and roles that will see this Announcement.</div>
            <button type="button" class="btn btn-secondary" (click)="showAssign = true" [disabled]="loadingRecipients"
                cvLocalizedText langSection="Broadcasts" langKey="Assign">Assign</button>
                <cv-angular-assign-tool 
                type="broadcast"
                [showAll]="true"
                [singleAdd]="true" 
                [singleType]="false" 
                [retainSelected]="true" 
                [headerText]="'Assign Recipients'"
                buttonText="Assign" 
                [(showPopup)]="showAssign"
                (showPopupChange)="assignToolToggle($event)" 
                showTypes="emp"
                [dataTransfer]="groups"
                ></cv-angular-assign-tool>
	        <div class="mt-4 color-valyrianSteel" *ngIf="noRecipientsSet()">
                <span *ngIf="!loadingRecipients" cvLocalizedText langSection="Broadcasts" langKey="No_Recipients_Selected">No recipients selected</span>
                <span *ngIf="loadingRecipients">Loading recipients...</span>
	        </div><br *ngIf="!noRecipientsSet()" />
            <div class="bg-greekToMe color-theUpsideDown d-inline-block p-2 my-2 mr-2 rounded" style="width:294px" *ngFor="let recipient of service.save.RecipientAssignments">
                <div class="lato-bold d-flex">
                    <div class="flex-grow-1">{{recipient.group.GroupName}}</div>
                    <svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail mr-2 clickable" (click)="removeRecipient(recipient)">
                        <use href="../App_Themes/clearview-default/icons/utility/delete.svg#delete"></use>
                    </svg>
                </div>
                <div *ngFor="let role of recipient.roles; index as i" style="padding-left:32px">
                    <div class="mt-1" *ngIf="i < 6 || (i == 6 && recipient.roles.length == 7) || recipient.showAll">{{role?.ProfileName}}</div>
                </div>
                <div class="color-cerulean d-inline-block clickable" *ngIf="!recipient.showAll && recipient.roles.length > 7" (click)="recipient.showAll = true"
                    cvLocalizedText langSection="Broadcasts" langKey="See_More">See more</div>
                <div class="color-cerulean clickable" *ngIf="recipient.showAll" (click)="recipient.showAll = false" cvLocalizedText langSection="Broadcasts" langKey="See_Less">See less</div>
            </div>
        </div>
        <div class="d-flex align-items-center mt-5 mb-2">
            <img src="../App_Themes/clearview-default/icons/number/circle-2.svg">
            <div class="lato-bold font-size-16 color-theUpsideDown ml-4" cvLocalizedText langSection="Broadcasts" langKey="Name_Of_Announcement">Name of Announcement</div>
        <span class="color-redRyder font-size-12 ml-3">{{errorMessages.name}}</span>
        </div>
        <div class="ml-5">
            <input type="text" class="form-control" [(ngModel)]="service.save.Title" (change)="validateName()" maxlength="36" placeholder="Type Name Here" cvLocalizedPlaceholder langSection="Broadcasts" langKey="Type_Name_Here" />
        </div>
        <div class="d-flex align-items-center mt-5 mb-2">
            <img src="../App_Themes/clearview-default/icons/number/circle-3.svg">
            <div class="lato-bold font-size-16 color-theUpsideDown ml-4" cvLocalizedText langSection="Broadcasts" langKey="Message">Message</div>
        <span class="color-redRyder font-size-12 ml-3">{{errorMessages.body}}</span>
        <span class="color-redRyder font-size-12 ml-3">{{errorMessages.bodyMaxLength}}</span>
        </div>
        <div class="ml-5">
            <editor 
            placeholder="Body Text"
            class="editor"
            [(ngModel)]="service.save.BroadcastText" 
            (ngModelChange)="validateBody(); validateBodyMaxLength();"
            (onInit)="validateBodyMaxLength();"
            [init]="{
            selector: 'textarea.addWorkAidBodyEntry',
            menubar: false,
            statusbar: false,
            forced_root_block: 'div',
            newline_behavior: 'block',
            toolbar: 'fontselect | fontsizeselect | undo redo | bold italic underline forecolor | numlist bullist | alignleft aligncenter alignright alignjustify',
            invalid_elements: 'script',
            plugins: 'lists',
            paste_as_text: true,
            paste_preprocess: pastePreprocess,
            fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt 42pt 50pt 55pt 60pt',
            height: '250',
            language: tinyMceLanguage(),
            font_formats: 'Lato=lato,verdana;Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;' +
                'Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;' +
                'Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;' +
                'Webdings=webdings;Wingdings=wingdings,zapf dingbats'
            }"
            >
        </editor>
    </div>
    <div class="d-flex align-items-center mt-5 mb-2">
        <img src="../App_Themes/clearview-default/icons/number/circle-4.svg">
        <span class="lato-bold font-size-16 color-theUpsideDown ml-4">
            <span cvLocalizedText langSection="Broadcasts" langKey="Attachments">Attachments</span><span>&nbsp;</span>
            <span cvLocalizedText langSection="Broadcasts" langKey="Optional">(Optional)</span>
        </span>
    </div>
    <div class="ml-5">
        <div class="mb-2 color-valyrianSteel" cvLocalizedText langSection="Broadcasts" langKey="Attachment_Tooltip">You may attach multiple files.</div>
        <div class="d-flex justify-content-between align-items-center mb-3" style="width:112px">
            <label class="mb-0">
                <input type="file" class="fileUpload d-none" (change)="attachmentPicked($event)" />
                <svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail clickable">
                    <use href="../App_Themes/clearview-default/icons/utility/attachment.svg#attachment"></use>
                </svg>
            </label>
            <label class="mb-0">
                <input type="file" class="fileUpload d-none" (change)="attachmentPicked($event, true)" accept="image/*" />
                <svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail clickable">
                    <use href="../App_Themes/clearview-default/icons/utility/image.svg#image"></use>
                </svg>
            </label>
            <svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail clickable" (click)="hyperlinkPopupOpen = true">
                <use href="../App_Themes/clearview-default/icons/utility/link.svg#link"></use>
            </svg>
        </div>
        <div *ngFor="let attachment of service.save.Attachments; index as i" class="d-flex align-items-center">
            <div class="rounded shadow-sm d-inline-block p-2 border m-2" style="width:365px">
                <svg class="icon-16 fill-valyrianSteel">
                    <use href="../App_Themes/clearview-default/icons/utility/attachment.svg#attachment"></use>
                </svg>
            <span class="color-cerulean">{{attachment.AttachmentName}}.{{attachment.AttachmentExtension}}</span>
            </div>
        <button type="button" class="btn btn-secondary ml-2" (click)="removeAttachment(1, i)" cvLocalizedText langSection="Common" langKey="Remove">Remove</button>
        </div>
        <div *ngFor="let image of service.save.Images; index as i" class="d-flex align-items-center">
            <div class="font-size-12 rounded shadow-sm d-flex justify-content-center p-2 border m-2 position-relative" style="width:365px">
                <img style="max-height:164px; max-width:349px" [src]="'data:image/' + image.FileExtension + ';base64,' + image.FileString" *ngIf="image.FileString" />
                <img style="max-height:164px; max-width:349px" [src]="'../Admin/FileViewer.aspx?iid=' + image.ImageID" *ngIf="!image.FileString" />
            </div>
        <button type="button" class="btn btn-secondary ml-2" (click)="removeAttachment(2, i)" cvLocalizedText langSection="Common" langKey="Remove">Remove</button>
        </div>
        <div *ngFor="let hyperlink of service.save.Hyperlinks; index as i" class="d-flex align-items-center">
            <div class="font-size-12 rounded shadow-sm p-2 border m-2 position-relative" style="height:142px; width:365px; padding-bottom:6px !important">
                <a class="text-truncate d-inline-block pb-1 mw-100" [href]="hyperlink.HyperlinkAddress" target="_blank">
                    {{hyperlink.HyperlinkAddress}}
                </a>
                <div class="d-flex">
                    <a class="mr-2" [href]="hyperlink.HyperlinkAddress" target="_blank" style="text-decoration: none;">
                        <div *ngIf="hyperlink.ContentSecurityPolicyViolation || hyperlink.IframeAvailability != 0" class="d-flex justify-content-center align-items-center border">
                            <div class="d-flex flex-column align-items-center justify-content-center" style="width: calc(880px * 0.2); height: calc(490px * 0.2); opacity: 1; border: 1px solid #d2d6db; border-radius:3px">
                                <div>
                                    <svg class="icon-32 fill-valyrianSteel fill-hover-whaleTail" style="pointer-events:none; cursor:default;">
                                        <use href="../App_Themes/clearview-default/icons/utility/image.svg#image"></use>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="!hyperlink.ContentSecurityPolicyViolation && hyperlink.IframeAvailability == 0" class="d-flex justify-content-center align-items-center border" style="width: calc(880px * 0.2); height: calc(490px * 0.2);">
                            <div class="websiteModulePreview position-relative w-100 h-100">
                                <iframe [src]="hyperlink.HyperlinkAddress | safeUrl" style="width: 880px; height: 490px; pointer-events: none; opacity: 1;" frameborder="0" sandbox="" scrolling="no"></iframe>
                            </div>
                        </div>
                    </a>
                <overlay-scrollbars [options]="scrollOptions">
                    <div style="width:163px; height:97px">{{hyperlink.HyperlinkText}}</div>
                </overlay-scrollbars>
                </div>
            </div>
        <button type="button" class="btn btn-secondary ml-2" (click)="removeAttachment(3, i)" cvLocalizedText langSection="Common" langKey="Remove">Remove</button>
        </div>
    </div>
    <!-- 5: Announcement type -->
    <div class="d-flex align-items-center mt-5 mb-2">
        <img src="../App_Themes/clearview-default/icons/number/circle-5.svg">
        <span class="lato-bold font-size-16 color-theUpsideDown ml-4" cvLocalizedText langSection="Broadcasts" langKey="Announcement_Type">Announcement type</span>
    </div>
    <div class="ml-5">
        <div class="rounded border position-relative" style="width:492px; border-color:#A8AFB9 !important; z-index: 1;">
            <div class="announcementTypeSelect bg-greekToMe p-2 rounded d-flex align-items-center" [class.clickable]="!(editMode || reuseMode)" (click)="selectOpen = !(editMode || reuseMode)">
                <div class="mr-2 position-relative" style="width:65px; height:65px" [ngClass]="{ announcementsGeneralIcon: service.save.AnnouncementType == 0, announcementsPartyIcon: service.save.AnnouncementType == 1,
                    announcementsDateEventIcon: service.save.AnnouncementType == 2, announcementsIncentiveIcon: service.save.AnnouncementType == 3 }">
                    <div class="announcementsUrgentCircle position-absolute" *ngIf="service.save.Urgent"></div>
                </div>
                <div class="flex-grow-1" [ngSwitch]="service.save.AnnouncementType">
                    <div *ngSwitchCase="0">
                        <div class="font-size-18" style="font-weight:500" cvLocalizedText langSection="Broadcasts" langKey="General">General</div>
                        <div cvLocalizedText langSection="Broadcasts" langKey="General_Tooltip_Desc">Use this for general announcements.</div>
                        <div cvLocalizedText langSection="Broadcasts" langKey="General_Tooltip_Ex">Ex: Policy reminders, Recognition, etc</div>
                    </div>
                    <div *ngSwitchCase="1">
                        <div class="font-size-18" style="font-weight:500" cvLocalizedText langSection="Broadcasts" langKey="Party">Party</div>
                        <div cvLocalizedText langSection="Broadcasts" langKey="Party_Tooltip_Desc">Announcements for parties.</div>
                        <div cvLocalizedText langSection="Broadcasts" langKey="Party_Tooltip_Ex">Ex: Pizza parties, Birthdays, New Years parties, etc</div>
                    </div>
                    <div *ngSwitchCase="2">
                        <div class="font-size-18" style="font-weight:500" cvLocalizedText langSection="Broadcasts" langKey="Date_Event">Date/Event</div>
                        <div cvLocalizedText langSection="Broadcasts" langKey="Date_Event_Tooltip_Desc">Announce something happening on a certain date.</div>
                        <div cvLocalizedText langSection="Broadcasts" langKey="Date_Event_Tooltip_Ex">Ex: Enrollment Deadlines, Trainings, etc</div>
                    </div>
                    <div *ngSwitchCase="3">
                        <div class="font-size-18" style="font-weight:500" cvLocalizedText langSection="Broadcasts" langKey="Incentive">Incentive</div>
                        <div cvLocalizedText langSection="Broadcasts" langKey="Incentive_Tooltip_Desc">Announcements that allow agents to earn more money.</div>
                        <div cvLocalizedText langSection="Broadcasts" langKey="Incentive_Tooltip_Ex">Ex: Extra cash, upsell prizes, etc</div>
                    </div>
                </div>
                <svg class="icon-24 fill-valyrianSteel mr-4"><use href="../App_Themes/clearview-default/icons/utility/arrow-down.svg#arrow-down"></use></svg>
            </div>
            <div class="rounded border position-absolute clickable" style="width:492px; height:342px; top:-1px; left:-1px; border-color:#A8AFB9 !important" *ngIf="selectOpen"
                (click)="selectOpen = false">
                <div class="announcementTypeSelect bg-greekToMe p-2 rounded-top d-flex align-items-center" (click)="handleTypeChange(0)">
                    <div class="announcementsGeneralIcon mr-2 position-relative" style="width:65px; height:65px">
                        <div class="announcementsUrgentCircle position-absolute" *ngIf="service.save.Urgent"></div>
                    </div>
                    <div class="flex-grow-1">
                        <div class="font-size-18" style="font-weight:500" cvLocalizedText langSection="Broadcasts" langKey="General">General</div>
                        <div cvLocalizedText langSection="Broadcasts" langKey="General_Tooltip_Desc">Use this for general announcements.</div>
                        <div cvLocalizedText langSection="Broadcasts" langKey="General_Tooltip_Ex">Ex: Policy reminders, Recognition, etc</div>
                    </div>
                    <svg class="icon-24 fill-valyrianSteel mr-4"><use href="../App_Themes/clearview-default/icons/utility/arrow-down.svg#arrow-down"></use></svg>
                </div>
                <div class="announcementTypeSelect bg-greekToMe p-2 d-flex align-items-center" (click)="handleTypeChange(1)">
                    <div class="announcementsPartyIcon mr-2 position-relative" style="width:65px; height:65px">
                        <div class="announcementsUrgentCircle position-absolute" *ngIf="service.save.Urgent"></div>
                    </div>
                    <div>
                        <div class="font-size-18" style="font-weight:500" cvLocalizedText langSection="Broadcasts" langKey="Party">Party</div>
                        <div cvLocalizedText langSection="Broadcasts" langKey="Party_Tooltip_Desc">Announcements for parties.</div>
                        <div cvLocalizedText langSection="Broadcasts" langKey="Party_Tooltip_Ex">Ex: Pizza parties, Birthdays, New Years parties, etc</div>
                    </div>
                </div>
                <div class="announcementTypeSelect bg-greekToMe p-2 d-flex align-items-center" (click)="handleTypeChange(2)">
                    <div class="announcementsDateEventIcon mr-2 position-relative" style="width:65px; height:65px">
                        <div class="announcementsUrgentCircle position-absolute" *ngIf="service.save.Urgent"></div>
                    </div>
                    <div>
                        <div class="font-size-18" style="font-weight:500" cvLocalizedText langSection="Broadcasts" langKey="Date_Event">Date/Event</div>
                        <div cvLocalizedText langSection="Broadcasts" langKey="Date_Event_Tooltip_Desc">Announce something happening on a certain date.</div>
                        <div cvLocalizedText langSection="Broadcasts" langKey="Date_Event_Tooltip_Ex">Ex: Enrollment Deadlines, Trainings, etc</div>
                    </div>
                </div>
                <div class="announcementTypeSelect bg-greekToMe p-2 rounded-bottom d-flex align-items-center" (click)="handleTypeChange(3)">
                    <div class="announcementsIncentiveIcon mr-2 position-relative" style="width:65px; height:65px">
                        <div class="announcementsUrgentCircle position-absolute" *ngIf="service.save.Urgent"></div>
                    </div>
                    <div>
                        <div class="font-size-18" style="font-weight:500" cvLocalizedText langSection="Broadcasts" langKey="Incentive">Incentive</div>
                        <div cvLocalizedText langSection="Broadcasts" langKey="Incentive_Tooltip_Desc">Announcements that allow agents to earn more money.</div>
                        <div cvLocalizedText langSection="Broadcasts" langKey="Incentive_Tooltip_Ex">Ex: Extra cash, upsell prizes, etc</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="d-flex align-items-center mt-5 mb-2">
        <img src="../App_Themes/clearview-default/icons/number/circle-6.svg">
        <span class="lato-bold font-size-16 color-theUpsideDown ml-4" cvLocalizedText langSection="Broadcasts" langKey="Folder">Folder</span>
    <span class="color-redRyder font-size-12 ml-3">{{errorMessages.folder}}</span>
    </div>
    <div class="ml-5">
        <div class="mb-2 color-valyrianSteel" cvLocalizedText langSection="Broadcasts" langKey="Announcement_Folder_Tooltip">Organize your Announcements by departments, subjects, and other categories.</div>
        <input class="form-control" list="save-folders" [(ngModel)]="service.save.Folder" (ngModelChange)="validateFolder()" maxlength="28" cvLocalizedPlaceholder langSection="Left_Nav_Popup" langKey="Select_Or_Type" />
        <datalist id="save-folders">
            <option *ngFor="let folder of service.folders" [value]="folder">
        </datalist>
    </div>
    <div class="d-flex align-items-center mt-5 mb-2">
        <img src="../App_Themes/clearview-default/icons/number/circle-7.svg">
        <span class="lato-bold font-size-16 color-theUpsideDown ml-4" cvLocalizedText langSection="Broadcasts" langKey="Set_Importance">Set importance</span>
    </div>
    <div class="ml-5">
        <div class="mb-2 color-valyrianSteel" cvLocalizedText langSection="Broadcasts" langKey="Announcement_Urgent_Tooltip">Decide if the Announcement is Urgent or not. Urgent will mark the Announcement with an exclamation point.</div>
        <span cvLocalizedText langSection="Broadcasts" langKey="Urgent">Urgent</span>
    <div class="sgCustomCheckbox broadcastCustomCheckbox d-inline-block ml-3 clickable" style="top:3px; outline:none" (click)="service.save.Urgent = !service.save.Urgent">
            <input class="sgCustomChkInput" id="urgent" type="checkbox" [(ngModel)]="service.save.Urgent" />
            <label for="urgent"></label>
            <div></div>
        </div>
    <div class="d-inline-block ml-1 position-relative">
            <div style="width:30px" *ngIf="service.save.Urgent">ON</div>
            <div style="width:30px" *ngIf="!service.save.Urgent">OFF</div>
        </div>
    <svg class="icon-16 fill-redRyder position-relative" style="top:-2px" *ngIf="service.save.Urgent">
            <use href="../App_Themes/clearview-default/icons/utility/urgent.svg#urgent"></use>
        </svg>
    <svg class="icon-16 fill-valyrianSteel position-relative" style="top:-2px" *ngIf="!service.save.Urgent">
            <use href="../App_Themes/clearview-default/icons/utility/urgent.svg#urgent"></use>
        </svg>
    </div>
    <div class="d-flex align-items-center mt-5 mb-2">
        <img src="../App_Themes/clearview-default/icons/number/circle-8.svg">
        <span class="lato-bold font-size-16 color-theUpsideDown ml-4">
            <span cvLocalizedText langSection="Broadcasts" langKey="Schedule_Announcement">Schedule announcement</span>
        </span>
    <span class="color-redRyder font-size-12 ml-3">{{errorMessages.showDate}}</span>
    </div>
    <div class="ml-5">
        <div class="input-group">
            <div class="search-box click-search justify-content-start">
                <!-- TO DO: Add [disabled]="!service.allowShowDate" when calendar has disabled input  -->
                        <cv-baremetrics-calendar
                        class="d-block daterange daterange--single"
                        [(currentDate)]="service.save.ShowDate"
                        [required]="true"
                        [placeholder]="placeholderLocalized"
                        (dateChanged)="validateShowDate()"
                        [disabled]="!service.allowShowDate"
                                    ></cv-baremetrics-calendar>
            </div>
        </div>
    </div>
    <div class="d-flex align-items-center mt-5 mb-2" *ngIf="service.save.AnnouncementType == 2">
        <img src="../App_Themes/clearview-default/icons/number/circle-9.svg">
        <span class="lato-bold font-size-20 ml-4" cvLocalizedText langSection="Broadcasts" langKey="Event_Date">Event Date</span>
        <span class="color-redRyder font-size-12 ml-3">{{errorMessages.eventDate}}</span>
    </div>
    <div class="ml-5" *ngIf="service.save.AnnouncementType == 2">
        <div class="input-group">
            <div class="search-box click-search justify-content-start">
                    <cv-baremetrics-calendar
                    class="d-block daterange daterange--single" 
                    style="width:112px"
                    [(currentDate)]="service.save.EventDate"
                    [required]="service.save.AnnouncementType == 2"
                    [placeholder]="placeholderLocalized"
                    (dateChanged)="validateEventDate()" 
                ></cv-baremetrics-calendar>
            </div>
        </div>
    </div>
    <div class="d-flex align-items-center mt-5 mb-2">
        <img src="../App_Themes/clearview-default/icons/number/circle-9.svg" *ngIf="service.save.AnnouncementType != 2">
        <img src="../App_Themes/clearview-default/icons/number/circle-10.svg" *ngIf="service.save.AnnouncementType == 2">
        <span class="lato-bold font-size-16 color-theUpsideDown ml-4">
            <span cvLocalizedText langSection="Broadcasts" langKey="Additional_Scheduling">Additional scheduling</span><span>&nbsp;</span>
            <span cvLocalizedText langSection="Broadcasts" langKey="Optional">(Optional)</span>
        </span>
    </div>
    <div class="ml-5 d-flex">
        <div class="pr-4">
            <div class="mb-1" cvLocalizedText langSection="Broadcasts" langKey="Announcement_Expires">Announcement expires</div>
            <div class="input-group">
                <div class="search-box click-search justify-content-start flex-wrap" style="width:176px">
                    <cv-baremetrics-calendar
                    class="d-block daterange daterange--single" 
                    style="width:112px;"
                    [(currentDate)]="service.save.ExpirationDate"
                    [required]="false"
                    [placeholder]="placeholderLocalized"
                    (dateChanged)="validateExpirationDate()" 
                ></cv-baremetrics-calendar>
                    <div class="color-redRyder font-size-12">{{errorMessages.expirationDate}}</div>
                </div>
            </div>
        </div>
        <div>
            <div class="mb-1" cvLocalizedText langSection="Broadcasts" langKey="Remind_Resend">Remind/Resend</div>
            <div class="input-group">
                <div class="search-box click-search justify-content-start flex-wrap" style="width:176px">
                    <cv-baremetrics-calendar
                    class="d-block daterange daterange--single" 
                    style="width:112px;"
                    [(currentDate)]="service.save.RemindDate"
                    [required]="false"
                    [placeholder]="placeholderLocalized"
                    (dateChanged)="validateRemindDate()" 
                ></cv-baremetrics-calendar>
                    <div class="color-redRyder font-size-12">{{errorMessages.remindDate}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="d-flex justify-content-end align-items-baseline mt-5">
        <div class="color-redRyder font-size-12 mr-3" *ngIf="!noErrorMessages()"
            cvLocalizedText langSection="Broadcasts" langKey="Announcement_Errors">Errors exist in announcement</div>
        <button type="button" class="btn btn-text mr-2" (click)="cancel()" cvLocalizedText langSection="Common" langKey="Cancel_Button">Cancel</button>
        <button type="button" class="btn btn-secondary mr-4" (click)="saveNew(true)" *ngIf="addMode" [disabled]="!noErrorMessages()"
            cvLocalizedText langSection="Broadcasts" langKey="Save_As_Draft">Save as draft</button>
        <button type="button" class="btn btn-secondary mr-4" (click)="openEditConfirmation(true)" [disabled]="!noErrorMessages()" *ngIf="editMode || reuseMode"
            cvLocalizedText langSection="Broadcasts" langKey="Save_As_Draft">Save as draft</button>
            <button type="button" class="btn btn-primary" (click)="saveNew(false)" *ngIf="addMode" [disabled]="!noErrorMessages()"
            cvLocalizedText langSection="Broadcasts" langKey="Share">Share</button>
        <button type="button" class="btn btn-primary" (click)="openEditConfirmation(false)" *ngIf="editMode || reuseMode" [disabled]="!noErrorMessages()"
            cvLocalizedText langSection="Broadcasts" langKey="Share">Share</button>
    </div>
</div>
<div class="w-100 h-100 fixed-top bg-whaleTail" style="opacity:0.6; z-index:999" *ngIf="hyperlinkPopupOpen || editConfirmationOpen"
    (click)="closeHyperlinkPopup(); editConfirmationOpen = false"></div>
<div class="broadcastPopupWindow bg-white rounded shadow mx-auto py-3 px-4 position-fixed" style="width:55%; height:70%" *ngIf="hyperlinkPopupOpen">
    <button type="button" class="broadcastPopupCloseBtn icon-btn fill-valyrianSteel fill-hover-whaleTail position-absolute" (click)="closeHyperlinkPopup()">
        <svg class="icon-16">
            <use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
        </svg>
    </button>
    <div class="border-bottom" style="height:48px">
        <span class="font-size-24 position-relative" style="left:-8px" cvLocalizedText langSection="Broadcasts" langKey="Hyperlink_Popup_Title">Add Hyperlink</span>
    </div>
    <div class="broadcastAddAttachmentPopupMainContainer w-100 py-4">
        <div class="broadcastAddAttachmentPopupInnerContainer position-absolute">
            <div class="pb-2">
                <span class="lato-bold" cvLocalizedText langSection="Broadcasts" langKey="Text_To_Display">Text to display</span>:
            <span class="color-redRyder font-size-12 ml-3">{{errorMessages.hyperlinkText}}</span>
            </div>
            <input type="text" class="form-control mb-3" [(ngModel)]="hyperlinkTextTemp" (change)="validateHyperlinkText()"
                placeholder="Type Here" maxlength="50" cvLocalizedPlaceholder langSection="Broadcasts" langKey="Type_Here">
            <div class="pb-2 d-flex align-items-center">
                <span class="lato-bold" cvLocalizedText langSection="Broadcasts" langKey="Web_Address">Web Address (URL):</span>
                <div [attr.title]="hyperlinkTooltip" class="d-flex align-items-center">
                    <svg class="icon-16 fill-cerulean ml-1" style="cursor: pointer">
                        <use href="../App_Themes/clearview-default/icons/utility/info.svg#info"></use>
                    </svg>
                </div>
                <span class="color-redRyder font-size-12 ml-2">{{errorMessages.hyperlinkAddress}}</span>
            </div>
            <input type="text" class="form-control" placeholder="Insert Web Address" cvLocalizedPlaceholder langSection="Broadcasts" langKey="Insert_Web_Address"
            [ngClass]="{ 'is-valid' : iframeValidated && iframeAvailability == 0 && !validatingIframe && hyperlinkAddressTemp.length > 0 && !hyperlinkAddressTemp.startsWith('http://'),
            'is-invalid' : iframeValidated && iframeAvailability != 0 && iframeAvailability != 4 && !validatingIframe && hyperlinkAddressTemp.length > 0,
            'warning' : iframeValidated && iframeAvailability == 4 && !validatingIframe && hyperlinkAddressTemp.length > 0 && hyperlinkAddressTemp.startsWith('http://') }"
            [disabled]="validatingIframe" 
            [(ngModel)]="hyperlinkAddressTemp" 
            (ngModelChange)=" iframeValidated= false; validateHyperlinkAddress();"
            (ngModelChangeDebounced)="validateIframe();"
            [ngModelChangeDebounceTime]="500"/>
            <!-- Hyperlink Validation Errors -->
            <div class="font-size-12 pb-3 mb-1">
                <span class="color-redRyder" *ngIf="!validatingIframe && iframeValidated && hyperlinkAddressTemp.length > 0">
                    <span *ngIf="hyperlinkAddressTemp.length <= 0" cvLocalizedText langSection="Website_Modules" langKey="Address_Required">URL is required.</span>
                    <span *ngIf="iframeAvailability == 1" cvLocalizedText langSection="Website_Modules" langKey="Address_Not_A_Url">Invalid URL. Check spelling and try again.</span>
                    <span *ngIf="iframeAvailability == 2" cvLocalizedText langSection="Website_Modules" langKey="Address_Invalid">This URL does not point to a reachable webpage.</span>
                    <span *ngIf="iframeAvailability == 3" cvLocalizedText langSection="Website_Modules" langKey="Address_Rejected">URL does not allow access from within this product.</span>
                </span>
                <span style="color:#E8961C" *ngIf="hyperlinkAddressTemp.length > 0 && iframeAvailability == 4 && !validatingIframe && iframeValidated"
                    cvLocalizedText langSection="Website_Modules" langKey="Address_Insecure">Warning, the connection to this website is not secure.</span>
            </div>
            <div>
                <div *ngIf="iframeAvailability === 0 && !previewFailed" class="websiteModulePreview position-absolute" style="width: calc(1536px * 0.2); height: calc(864px * 0.2);" [hidden]="!hyperlinkAddressTemp || hyperlinkAddressTemp == '' || validatingIframe || !iframeValidated">
                    <iframe id="modalIframe" [src]="hyperlinkAddressTemp | safeUrl" style="width: 1536px; height: 864px; pointer-events: none; opacity: 1;  border: 7px solid #d2d6db; border-radius:15px" frameborder="0" sandbox="" scrolling="no"></iframe>
                </div>
            </div>
            <div *ngIf="(iframeAvailability != 0 && !validatingIframe && iframeValidated) || previewFailed">
                <div class="d-flex flex-column align-items-center justify-content-center position-absolute" style="width: 310px; height:120px; opacity: 1; border: 1px solid #d2d6db; border-radius:3px">
                    <div class="d-flex flex-column align-items-center justify-content-center position-absolute">
                        <svg class="icon-32 fill-valyrianSteel fill-hover-whaleTail" style="pointer-events:none; cursor:default;">
                            <use href="../App_Themes/clearview-default/icons/utility/image.svg#image"></use>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="broadcastAddAttachmentPopupBtnContainer d-flex justify-content-end border-top position-absolute">
        <button type="button" class="btn btn-text mr-2" (click)="closeHyperlinkPopup()" cvLocalizedText langSection="Common" langKey="Cancel_Button">Cancel</button>
        <button type="button" class="btn btn-primary" [disabled]="validatingIframe || iframeAvailability== 1 || iframeAvailability ==2 || iframeAvailability==4 || hyperlinkAddressTemp.length <= 0 || !iframeValidated" (click)="addHyperlink()" cvLocalizedText langSection="Common" langKey="Apply">Apply</button>
    </div>
</div>
<div class="broadcastPopupWindow bg-white rounded shadow mx-auto position-fixed broadcastEditPopup" style="height:auto;" *ngIf="editConfirmationOpen">
    <button type="button" class="broadcastPopupCloseBtn icon-btn fill-valyrianSteel fill-hover-whaleTail position-absolute" (click)="service.save.Draft = false; editConfirmationOpen = false">
        <svg class="icon-16">
            <use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
        </svg>
    </button>
    <div class="font-size-20 pb-4" cvLocalizedText langSection="Broadcasts" langKey="Changes_Made">Changes have been made</div>
    <!--Force major if old show date was in the future but now is in the past, force minor if it was in the future and still is in the future (maybe even skip the confirmation)-->
    <div class="mt-2 mb-3 d-flex" style="margin-left:12px">
        <input type="radio" name="major" [(ngModel)]="service.save.MinorEdit" value="false" id="major" [disabled]="service.minorMajorForced" />
        <label class="ml-2 mt-2 clickable" for="major" cvLocalizedText langSection="Broadcasts" langKey="Major_Edit">Save changes, clear read receipts, and resend to users</label>
    </div>
    <div class="d-flex" style="margin-left:12px">
        <input type="radio" name="minor" [(ngModel)]="service.save.MinorEdit" value="true" id="minor" [disabled]="service.minorMajorForced" />
        <label class="ml-2 mt-2 clickable" for="minor" cvLocalizedText langSection="Broadcasts" langKey="Minor_Edit">Save changes only</label>
    </div>
    <div class="mb-3 mt-2">
        <div class="d-flex justify-content-end" style="bottom:16px; right:16px">
            <button type="button" class="btn btn-text mr-2" (click)="editConfirmationOpen = false" cvLocalizedText langSection="Common" langKey="Cancel_Button">Cancel</button>
            <button type="button" class="btn btn-primary" (click)="saveEdit()" cvLocalizedText langSection="Common" langKey="Apply">Apply</button>
        </div>
    </div>
</div>
</div>



